export default __webpack_public_path__ + "static/open-sans-v15-latin-700-7435e6c2064f36f486266e516e9838b8.woff2";